/* Dynamic Plot code copyright 2015 (c) Tuva Labs Inc. */
/**
 *
 * created by jpatel
 */

import React from 'react';
import ResetFilterComponent from './ResetFilterComponent.jsx';
import Select from '../../common/Select';
import { DropdownIndicator } from '../../../utils/dropdown-override';
import ToolTip from '../../common/ToolTip.js';

class MonthDayRangeComponent extends React.Component {
  constructor(props) {
    super(props);
    let Dyn = this.props.Dyn;

    /**
     * set the range using leftNumber and rightNumber from attribute statsPreFilter
     * and initial values for the indicators by reading it from attribute stats
     * Its based on the range calculated by the scale
     */
    var filter = Dyn.dataSet.caseFilter.getAttributeFilter( this.props.attributeObj.id ),
        currentMin = (filter?.numeric) ? filter.numeric.min : this.props.attributeObj.statsPreFilter.min,
        currentMax = (filter?.numeric) ? filter.numeric.max : this.props.attributeObj.statsPreFilter.max;
    this.state = {
      leftNumber: currentMin,
      rightNumber: currentMax,
      storedNumber: currentMin
    };
  }

  /**
   * A function that takes two arguments, the first representing the x-position of the slider and
   * the second the width of the slider. Use this to control the mapping of the domain of numbers
   * the slider represents onto the range of pixel locations of the slider. By default,
   * this is set to the non-linear - It can be specified in the slider configuration
   */
  scalingFunction = (x, constantBase) => {

    // return Math.pow(x, 2) / Math.pow(constantBase, 2);
  }

  // Typed conditions cannot go out of bounds, but they can cross
  typedConditionsMet = (state) => {

    // left needs to be less than right
    return state.leftNumber <= state.rightNumber;
  }

  getOtherDirection = (thisDirection) => {

    var directions = ["left", "right"];
    var otherIndex = (directions.indexOf(thisDirection) + 1) % 2;
    return directions[otherIndex];
  }

  onChange = ( key, obj ) => {

    var   stateObject = {},
      targetClassName = key,
            direction = targetClassName.match(/(\w+)Number/)[1],
       otherDirection = this.getOtherDirection(direction),
           targetValue = obj.value;

    // Restrictions on entered values. Storage of temporary value when user clears
    if( targetValue.match(/^[-+]?(\d+\.?|\d*\.\d+)$/) ) {
      stateObject[targetClassName] = Number(targetValue);
    } else if (targetValue === "") {
      stateObject[targetClassName] = "";
      stateObject.storedNumber = this.state[targetClassName];
      this.setState(stateObject);
      return;
    } else
      return;

    var otherNumber = otherDirection + "Number",
        wrongInput = false;
    stateObject[otherNumber] = this.state[otherNumber];
    if (!this.typedConditionsMet(stateObject)){
      // if left is not less than right, don't do anything
      // highlight the item.
      wrongInput = true;
      // stateObject[otherNumber] = stateObject[targetClassName];
    }

    // stateObject = this.addPositionsFromNumbers(stateObject);
    this.setState(stateObject);

    if( !wrongInput ){
      // mediator.publish( "records:caseFilterByAttribute",{
      //   "attributeID": this.props.attributeObj.id,
      //   "numeric":{
      //     "min": stateObject.leftNumber,
      //     "max": stateObject.rightNumber
      //   }
      // } );

      // message to parent to rerender
      this.props.handleChange({
          filterChanged: true,
          dataType: 'numerical',
          subType: this.props.mode,
          filtered: {
              min: stateObject.leftNumber,
              max: stateObject.rightNumber
          }
      });
    }
  }

  onBlur = ( e ) => {

    // check the classname and value in obj.target
    var stateObject = {};
    var targetClassName = e.target.className;
    if (e.target.value === "")
      stateObject[targetClassName] = this.state.storedNumber;
    this.setState(stateObject);

  }

  onFocus = ( e ) => {

    // make the insert left align
    var   stateObject = {},
      targetClassName = e.target.className,
            direction = targetClassName,
                value = e.target.value;
    stateObject[targetClassName] = '';
    stateObject.storedNumber = this.state[targetClassName];
    this.setState(stateObject);
  }

  getLoc = (str) => {
    let Dyn = this.props.Dyn;
      return Dyn.loc( str );
  }

  render = () => {

    var leftNumber = this.state.leftNumber,
        rightNumber = this.state.rightNumber;

    if( this.props.resetFilter ){
      leftNumber = this.props.attributeObj.statsPreFilter.min;
      rightNumber = this.props.attributeObj.statsPreFilter.max;
    }

    var attributeObj = this.props.attributeObj,
        attributeType = this.state.value;

    if ( this.props.mode == 'month' ) {
      var options = [
          { value: "0", label: "January" },
          { value: "1", label: "February" },
          { value: "2", label: "March" },
          { value: "3", label: "April" },
          { value: "4", label: "May" },
          { value: "5", label: "June" },
          { value: "6", label: "July" },
          { value: "7", label: "August" },
          { value: "8", label: "September" },
          { value: "9", label: "October" },
          { value: "10", label: "November" },
          { value: "11", label: "December" }
        ];
    } else {
      var options = [
          { value: "0", label: "Sunday" },
          { value: "1", label: "Monday" },
          { value: "2", label: "Tuesday" },
          { value: "3", label: "Wednesday" },
          { value: "4", label: "Thursday" },
          { value: "5", label: "Friday" },
          { value: "6", label: "Saturday" },
        ];
    }

    // checking if while converting from categorical to numerical if there is
    // no valid numeric value.
    if( typeof(leftNumber) === 'undefined' || typeof(rightNumber) === 'undefined')
    {
      return (
        <div className="tde-numeric-component">
          <div className="tde-m-2 tde-text-error">{this.getLoc('No valid numeric value for the attribute.')}</div>
        </div>
      );
    } else {
      return (
        <div className="tde-numeric-component tde-pt-4 tde-mt-4 tde-divider-top tde-divider-bottom tde-pb-4">
            <div className={this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3'}>
                <div className="tde-row">
                    <div className="tde-s1 tde-font-weight-bold tde-attr-name tde-mb-2">{ this.getLoc('Filter Range') }<ToolTip tip={this.getLoc('Set minimum and maximum values')} Dyn={this.props.Dyn} dir="r"><i className="tde-i tde-i-help tde-ml-1"></i></ToolTip>
                    {this.props.isFiltered && <ResetFilterComponent value={ this.getLoc('Reset') } handleChange={this.props.handleChange} attributeObj={ this.props.attributeObj } isFiltered={ this.props.isFiltered }/>}
                    </div>
                </div>
                <div className="tde-row tde-my-2">
                    <div className="tde-label tde-mb-2">{ this.getLoc('Min') }</div>
                    <Select
                        Dyn={this.props.Dyn}
                        className="tde-input tde-select-input tde-input-select tde-monthday-range"
                        isClearable={false}
                        value={options.find(obj => obj.value == leftNumber)}
                        options={options}
                        // openMenuOnFocus
                        isSearchable={false}
                        tabSelectsValue={false}
                        onChange={this.onChange.bind(this, 'leftNumber')}
                        components={{
                            Option: ({ data, innerProps, children,innerRef,isSelected,isFocused }) => (
                                <div className={'tde-select-option' + (isSelected ? ' tde-selected' :"") + (isFocused ? ' tde-focused' : '')} title={data.title} {...innerProps} ref={innerRef}>
                                    <div className="tde-s1">{children}</div>
                                </div>
                            ),
                            DropdownIndicator
                        }}
                    />
                </div>
                <div className="tde-row tde-my-2">
                    <div className="tde-label tde-mb-2">{ this.getLoc('Max') }</div>
                    <Select
                        Dyn={this.props.Dyn}
                        className="tde-input tde-select-input tde-input-select"
                        isClearable={false}
                        value={options.find(obj => obj.value == rightNumber)}
                        options={options}
                        // openMenuOnFocus
                        isSearchable={false}
                        tabSelectsValue={false}
                        onChange={this.onChange.bind(this, 'rightNumber')}
                        components={{
                            Option: ({ data, innerProps, children,innerRef,isSelected,isFocused }) => (
                                <div className={'tde-select-option' + (isSelected ? ' tde-selected' :"") + (isFocused ? ' tde-focused' : '')} title={data.title} {...innerProps} ref={innerRef}>
                                    <div className="tde-s1">{children}</div>
                                </div>
                            ),
                            DropdownIndicator
                        }}
                    />
                </div>
            </div>
        </div>

      );
    }
  }
}

export default MonthDayRangeComponent;
